<template>
    <b-row v-if="proposal">
        <!-- <CreditEligibilityCheck :show_eligibility_check.sync="modals.show_eligibility_check"/> -->
        <b-col cols="12" md="5">
            <b-card no-body class="p-3">
							<b-row class="mb-3">
                    <b-col cols="12" class="d-flex align-items-center justify-content-between">
                        <p class="font-weight-500">Credit Application Info</p>
                        <!-- <p class="text-primary font-weight-400 d-block d-md-inline-block cursor-pointer" v-if="customer_ctos">History ></p> -->
                    </b-col>
                </b-row>
								<b-row>
									<b-col cols="12" md="6">
										<p>Credit Loan Application</p>
                    <h4>RM {{ _gHlp.getValue(currentInvSummary,'loan_amount',0) | moneyFormatter }}</h4>
									</b-col>
									<b-col cols="12" md="6">
										<p>Credit Eligibility Check</p>
                    <h4>{{ _gHlp.getValue(currentInvSummary,'status','Pre-screening') }}</h4>
									</b-col>
									<b-col cols="12" md="12">
										<p>Credit Processing Status</p>
                    <h4>{{ credit_process_status }}</h4>
									</b-col>
							</b-row>
            </b-card>
        </b-col>
        <b-col cols="12" md="7">
            <b-card no-body class="p-3">
                <b-row class="mb-3">
                    <b-col cols="12" class="d-flex align-items-center justify-content-between">
                        <p class="font-weight-500">FINTSCORE Report</p>
                        <!-- <p class="text-primary font-weight-400 d-block d-md-inline-block cursor-pointer" v-if="customer_ctos">History ></p> -->
                    </b-col>
                </b-row>
                <div v-if="customer_ctos">
                    <b-row>
                        <b-col cols="6" md="4">
                            <div class="d-flex align-items-center">
                                <h3 class="mb-0 mr-1" v-if="ctos.is_saa"><b-icon icon="x-lg" variant="danger"></b-icon></h3>
                                <h3 class="mb-0 mr-1" v-else><b-icon icon="check-lg" variant="success"></b-icon></h3>
                                <span class="mx-1">SAA</span>
                            </div>
                            <div class="d-flex align-items-center">
                                <h3 class="mb-0 mr-1" v-if="ctos.is_legal"><b-icon icon="x-lg" variant="danger"></b-icon></h3>
                                <h3 class="mb-0 mr-1" v-else><b-icon icon="check-lg" variant="success"></b-icon></h3>
                                <span class="mx-1">Legal Cases</span>
                            </div>
                        </b-col>
                        <b-col cols="6" md="4">
                            <div class="d-flex align-items-center">
                                <h3 class="mb-0 mr-1" v-if="ctos.is_bankruptcy"><b-icon icon="x-lg" variant="danger"></b-icon></h3>
                                <h3 class="mb-0 mr-1" v-else><b-icon icon="check-lg" variant="success"></b-icon></h3>
                                <span class="mx-1">Bankruptcy</span>
                            </div>
                            <div class="d-flex align-items-center">
                                <h3 class="mb-0 mr-1" v-if="ctos.is_trade_references"><b-icon icon="x-lg" variant="danger"></b-icon></h3>
                                <h3 class="mb-0 mr-1" v-else><b-icon icon="check-lg" variant="success"></b-icon></h3>
                                <span class="mx-1">Trade References</span>
                            </div>
                        </b-col>
                        <b-col cols="6" md="4">
                            <div class="d-flex align-items-center">
                                <h3 class="mb-0 mr-1" v-if="ctos.is_akpk"><b-icon icon="x-lg" variant="danger"></b-icon></h3>
                                <h3 class="mb-0 mr-1" v-else><b-icon icon="check-lg" variant="success"></b-icon></h3>
                                <span class="mx-1">AKPK</span>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="12" class="d-flex align-items-center justify-content-between">
                            <p class="text-primary font-weight-400 d-block d-md-inline-block cursor-pointer" @click="mortgageEligibleCheck">Mortgage Eligible</p>
                            <p class="text-primary font-weight-400 d-block d-md-inline-block cursor-pointer" 
                                v-if="customer_ctos.credit_report_fintscore_unsigned_url"
                                @click="$refs.preview_modal.preview(customer_ctos.credit_report_fintscore_unsigned_url)"
                            >View report ></p>
                        </b-col>
                    </b-row>
                </div>
                <div class="py-4 text-center text-danger" v-else>Customer has not yet purchased Credit Report.</div>
            </b-card>
        </b-col>
        <PreviewModal ref="preview_modal"></PreviewModal>
        <MortgageEligibleModal ref="mortgage_eligible_modal"/>
    </b-row>
</template>
<script>
import PreviewModal  from '@/components/Modal/PreviewModal'
// import CreditEligibilityCheck from '@/views/InitialProposal/Modals/CreditEligibilityCheckModal'
import MortgageEligibleModal from '@/views/InitialProposal/Modals/MortgageEligibleModal.vue'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'

export default {
    props: ['proposal', 'customer_ctos'],
    components: {
        MortgageEligibleModal,
        PreviewModal,
        // CreditEligibilityCheck
    },
    data() {
        return {
            ctos: {
                is_akpk: false,
                is_trade_references: false,
                is_saa: false,
                is_legal: false,
                is_bankruptcy: false,
            },
            modals: {
                show_eligibility_check: false
            },
        }
    },
		computed: {
			...mapState(useInvinityStore, ['currentInvSummary']),
			credit_process_status(){
				if(_gHlp.isEmpty(this.currentInvSummary) || _gHlp.isEmpty(this.currentInvSummary.case_detail)) return "Pre-Screening";
				return _gHlp.getValue(this.currentInvSummary,'case_detail.case_id','-') + '/' +_gHlp.getValue(this.currentInvSummary,'case_detail.case_loan_type','-')+ '/' +_gHlp.getValue(this.currentInvSummary,'case_detail.case_status','-')
			}
		},
    watch:{
        customer_ctos:{
            handler(newVal){
								if(!_gHlp.isEmpty(newVal)){
									this.ctos.is_saa = newVal.credit_report_summary.special_attensions.length > 0
									this.ctos.is_legal = newVal.credit_report_summary.legal_cases.length > 0
									this.ctos.is_bankruptcy = newVal.credit_report_summary.bankruptcies.length > 0
									this.ctos.is_trade_references = newVal.credit_report_summary.trade_references.length > 0
									this.ctos.is_akpk = newVal.credit_report_summary.akpk.length > 0
								}
            },
            immediate: true
        }
    },
    methods:{
        mortgageEligibleCheck(){
            this.$refs.mortgage_eligible_modal.check(this.proposal.psal_customer_id)
        }
    }
}
</script>